import React from "react";
import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";

import { withApollo } from "react-apollo";
import {
  createCategory,
} from "../../services/graphql/queries/category-management";

import ReactModal from "../Common/ReactModal";
import InputComponent from "../Common/form-component/InputComponent";
import TextAreComponent from "../Common/form-component/TextAreComponent";
import DisplayErrors from "../Common/DisplayErrors";

import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../miscellaneous/react-toastify";

import {
  SET_TIMEOUT_VALUE,
} from "../../constants/app-constants";

class DocumentAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      documentDetail: {
        name: "",
        displayOrder: 100,
        description: "",
        manager: "",
        client: "",
        projectId: ""
      },
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: message => <div style={{ color: "red" }}>{message}</div>
    });
    this.handleInput = this.handleInput.bind(this);
    this.addDocument = this.addDocument.bind(this);
  }

  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(prevState => {
      return {
        documentDetail: {
          ...prevState.documentDetail,
          [name]: value
        }
      };
    });
  }

  addDocument(e) {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.state.documentDetail.displayOrder = parseInt(this.state.documentDetail.displayOrder)
      console.log("params",this.state.documentDetail)
      this.props.client
        .mutate({
          mutation: createCategory,
          variables: this.state.documentDetail,
          fetchPolicy: "no-cache"
        })
        .then(result => {
          successMsg("Project Created Successfullly")
          localStorage.setItem("categoryId", result.data.createCategory.category.id)
          this.props.history.push(
            "/category-detail?id=" + result.data.createCategory.category.id+"&create=true"
          );
        })
        .catch(error => {
          console.log("~~~error: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({ loading: false, errors: [errorMessage(error)] });
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      this.validator.showMessages();
      
      
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  }

  onFormClear() {
    let documentDetail = {
      name: "",
      displayOrder: 100,
      description: "",
      manager: "",
      client: "",
      projectId: ""
    };
    this.validator.hideMessages();
    this.setState({ documentDetail: documentDetail });
  }

  componentDidMount() {
  }

  render() {
    const {
      errors,
      documentDetail,
    } = this.state;
    console.log("documentDetail",documentDetail)
    return (
      <>
        <h1 className="heading m-b-25">Project Creation</h1>
        <div
          className="row"
          style={{
            display: errors.length === 0 ? "none" : "block"
          }}
        >
          <div className="col-md-6">
            <div className="alert alert-success" role="alert">
              <div className="row">
                <span className="danger-link">
                  <DisplayErrors errors={errors} />
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Form Section start */}
        <form onSubmit={this.addDocument}>
          <div className="row">
            <div className="col-md-12">
              <div className="box-card">
                <div className="row">
                  <div className="col-md-4 col-lg-4">
                    <InputComponent
                      required
                      type="text"
                      title="Name"
                      name="name"
                      label="Name"
                      value={documentDetail.name}
                      placeholder="Enter Name"
                      handleChange={this.handleInput}
                      validator={this.validator}
                      validation="required"
                    />
                  </div>
                  <div className="col-md-4 col-lg-4">
                    <InputComponent
                      required
                      type="text"
                      title="Project Id"
                      name="projectId"
                      label="Project Id"
                      value={documentDetail.projectId}
                      placeholder="Enter Project Id"
                      handleChange={this.handleInput}
                      validator={this.validator}
                      validation="required"
                    />
                  </div>
                  <div className="col-md-6 col-lg-4">
                  <InputComponent
                    required
                    type="text"
                    title="Manager"
                    name="manager"
                    label="Manager"
                    value={documentDetail.manager}
                    placeholder="Enter Manager Name"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
                <div className="col-md-6 col-lg-4">
                  <InputComponent
                    required
                    type="text"
                    title="Client"
                    name="client"
                    label="Client"
                    value={documentDetail.client}
                    placeholder="Enter Client Name"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
                <div className="col-md-2 col-lg-4">
                    <InputComponent
                      required
                      type="number"
                      title="Display Order"
                      name="displayOrder"
                      label="Display Order"
                      value={documentDetail.displayOrder}
                      placeholder="Enter Display Order"
                      handleChange={this.handleInput}
                      validator={this.validator}
                      validation="required"
                    />
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <TextAreComponent
                      required
                      title="Description"
                      name="description"
                      label="Description"
                      value={documentDetail.description}
                      placeholder="Enter Description"
                      handleChange={this.handleInput}
                      validator={this.validator}
                      validation="required"
                    />
                  </div>
            
                </div>
              </div>
            </div>
          </div>
          <div className="row m-t-25 m-b-25">
            <div className="col-md-12 col-lg-5">
              <button type="submit" className="btn btn-danger">
                Submit
              </button>
              <button
                type="button"
                className="btn btn-light m-l-50"
                onClick={() => this.onFormClear()}
              >
                Clear
              </button>
            </div>
          </div>
        </form>
        {/* Form Section End */}
      </>
    );
  }
}

export default withRouter(withApollo(DocumentAdd));
